import SportSelectionItem from "./SportSelectionItem";
import { availableSportNames } from "../../../../utilities/Constants";

const SportSelection = () => {
  return (
    <div className="sport-selection-container">
      {availableSportNames.map((sport, key) => (
        <SportSelectionItem
          item={sport}
          key={key}
          checked={key === 0 ? true : false}
        />
      ))}
    </div>
  );
};

export default SportSelection;
